import React, { useEffect, useState } from "react";
import { useParams,useNavigate } from "react-router-dom";
import {
  Avatar,
  Form,
  Input,
  Select,
  Button,
  Spin,
  Tag,
  Card,
  Statistic,
  Divider
} from "antd";
import {
  UserOutlined
} from "@ant-design/icons";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function StudentDetails() {
  const { id } = useParams();
 
   const navigate = useNavigate();
  
    // Auth info
    const token = localStorage.getItem("token");
    const fullName = localStorage.getItem("fullName");
    const role = (localStorage.getItem("role") || "").toUpperCase();
  
    useEffect(() => {
      if (!token || !fullName || !role) {
        navigate("/user/sign_in");
      }
    }, [token, fullName, role, navigate]);

  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState(null);
  const [form] = Form.useForm();

  useEffect(() => {
    const loadStudent = async () => {
      try {
        setLoading(true);

        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/user/student/${id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        if (response.data.success) {
          setUser(response.data.data);
          form.setFieldsValue(response.data.data);
        }
      } finally {
        setLoading(false);
      }
    };

    loadStudent();
  }, [id, token, form]);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-slate-100">
        <Spin size="large" />
      </div>
    );
  }

  if (!user) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-slate-100">
        Student not found
      </div>
    );
  }

  const formatDate = (date) => {
  if (!date) return "-";

  const d = new Date(date);
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();

  return `${day}-${month}-${year}`;
};

const calculateDaysLeft = (endDate) => {
  if (!endDate) return null;

  const today = new Date();
  const end = new Date(endDate);

  const diffTime = end - today;
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  return diffDays;
};

const daysLeft = calculateDaysLeft(user.PlatformAccessEndDate);

const handleUpdateStudent = async () => {
  try {
    const values = await form.validateFields();

    const response = await axios.put(
      `${process.env.REACT_APP_API_URL}/user/student/update`,
      {
        ...values,
        Email: user.Email, 
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (response?.data?.success) {
      toast.success("Student updated successfully ✅");
      setUser({ ...user, ...values });
    } else {
      toast.error(response?.data?.message || "Update failed ❌");
    }

  } catch (error) {
    toast.error(
      error?.response?.data?.message || "Server error ❌"
    );
  }
};

  return (
    <div className="min-h-screen bg-slate-100">
       <ToastContainer
        position="bottom-left"
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
        className="!mb-6 !ml-4"
        toastClassName="!inline-flex !items-center !whitespace-nowrap !bg-black !text-white !px-4 !py-2 !rounded-lg !w-auto !min-w-0 !shadow-lg"
      />

      {/* 🔥 HERO HEADER */}
      <div className="px-10 py-12 m-3 text-white shadow-2xl bg-gradient-to-r from-indigo-600 via-purple-600 to-emerald-500 rounded-3xl">
        <div className="flex flex-col items-center gap-6 md:flex-row">

          <Avatar
            size={130}
            src={user.ProfilePhotoUrl}
            icon={<UserOutlined />}
            className="border-4 border-white shadow-xl"
          />

          <div>
            <h1 className="text-4xl font-bold tracking-wide">
              {user.FullName}
            </h1>

            <p className="mt-2 text-lg opacity-90">
              {user.Email}
            </p>

            <div className="flex gap-3 mt-4">
              <Tag color="geekblue" className="px-4 py-1 text-sm">
                {user.LeadType}
              </Tag>

              <Tag
                className={`px-4 py-1 text-sm font-semibold ${
                  user.StudentStatus === "ACTIVE"
                    ? "bg-emerald-500 text-white"
                    : "bg-rose-500 text-white"
                }`}
              >
                {user.StudentStatus}
              </Tag>
            </div>
          </div>
        </div>
      </div>

      <div className="px-10 py-12">

      {/* 📊 KPI SECTION */}
<div className="grid grid-cols-1 gap-6 mb-12 md:grid-cols-4">

  {/* Courses */}
  <Card className="font-bold border-0 shadow-lg rounded-3xl bg-gradient-to-br from-indigo-50 to-indigo-100">
    <Statistic
      title="Courses Enrolled"
      value={user.CoursesEnrolled || 0}
      valueStyle={{ color: "#4f46e5" }}
    />
  </Card>

  {/* Mock Interviews */}
  <Card className="font-bold border-0 shadow-lg rounded-3xl bg-gradient-to-br from-emerald-50 to-emerald-100">
    <Statistic
      title="Mock Interviews Left"
      value={user.MockInterviewsLeft || 0}
      valueStyle={{ color: "#059669" }}
     
    />
  </Card>

  {/* Enrolled Date */}
  <Card className="font-bold border-0 shadow-lg rounded-3xl bg-gradient-to-br from-sky-50 to-sky-100">
    <div>
      <div className="text-sm text-gray-500">
        Enrolled Date
      </div>
      <div className="mt-2 text-lg font-semibold text-sky-700">
        {formatDate(user.EnrolledDate)}
      </div>
    </div>
  </Card>

  {/* 🔥 Platform Access Dashboard */}
  <Card className="font-bold border-0 shadow-lg rounded-3xl bg-gradient-to-br from-rose-50 to-rose-100">

    <div className="flex items-center justify-between mb-3">
      <div className="text-sm text-gray-500">
        Platform Access Validity
      </div>

      {daysLeft !== null && (
        <span
          className={`px-3 py-1 text-xs font-semibold rounded-full ${
            daysLeft <= 0
              ? "bg-red-500 text-white"
              : daysLeft <= 7
              ? "bg-yellow-500 text-white"
              : "bg-emerald-500 text-white"
          }`}
        >
          {daysLeft <= 0
            ? "Expired"
            : `${daysLeft} Days Left`}
        </span>
      )}
    </div>

    <div className="space-y-1 text-sm text-gray-700">
      <div>
        Start:{" "}
        <span className="font-semibold text-emerald-600">
          {formatDate(user.PlatformAccessStartDate)}
        </span>
      </div>

      <div>
        End:{" "}
        <span className="font-semibold text-rose-600">
          {formatDate(user.PlatformAccessEndDate)}
        </span>
      </div>
    </div>

    {/* Progress Bar */}
    {daysLeft !== null && daysLeft > 0 && (
      <div className="mt-4">
        <div className="w-full h-2 bg-gray-200 rounded-full">
          <div
            className={`h-2 rounded-full ${
              daysLeft <= 7
                ? "bg-yellow-500"
                : "bg-emerald-500"
            }`}
            style={{
              width: `${Math.min((daysLeft / 90) * 100, 100)}%`,
            }}
          />
        </div>
      </div>
    )}

  </Card>

</div>

        {/* 🧾 FORM SECTION */}
        <div className="p-10 bg-white shadow-xl rounded-3xl">

          <h2 className="mb-10 text-2xl font-semibold text-slate-800">
            Student Profile Management
          </h2>

          <Form form={form} layout="vertical">

            <Divider orientation="left">Basic Information</Divider>

            <div className="grid grid-cols-1 gap-6 md:grid-cols-2">

              <Form.Item name="FullName" label="Full Name">
                <Input size="large" />
              </Form.Item>

              <Form.Item name="Email" label="Email Address">
                <Input size="large" />
              </Form.Item>

              <Form.Item name="PhoneNumber" label="Phone Number">
                <Input size="large" />
              </Form.Item>

              <Form.Item name="Country" label="Country">
                <Input size="large" />
              </Form.Item>

              <Form.Item name="LeadType" label="Lead Category">
                <Select size="large">
                  <Select.Option value="STUDENT">Student</Select.Option>
                  <Select.Option value="PROFESSIONAL">Professional</Select.Option>
                </Select>
              </Form.Item>

              <Form.Item name="StudentStatus" label="Student Status">
                <Select size="large">
                  <Select.Option value="ACTIVE">ACTIVE</Select.Option>
                  <Select.Option value="INACTIVE">INACTIVE</Select.Option>
                </Select>
              </Form.Item>

            </div>

            <Divider orientation="left">Education Details</Divider>

            <div className="grid grid-cols-1 gap-6 md:grid-cols-2">

              <Form.Item name="College" label="College / University">
                <Input size="large" />
              </Form.Item>

              <Form.Item name="Degree" label="Degree">
                <Input size="large" />
              </Form.Item>

              <Form.Item name="Branch" label="Branch / Specialization">
                <Input size="large" />
              </Form.Item>

              <Form.Item name="GraduationYear" label="Graduation Year">
                <Input size="large" />
              </Form.Item>

            </div>

            <Button
  type="primary"
  size="large"
  onClick={handleUpdateStudent}
  className="px-12 mt-10 !bg-emerald-600 hover:!bg-emerald-700 rounded-xl font-semibold"
>
  Save Changes
</Button>

          </Form>

        </div>

      </div>
    </div>
  );
}

export default StudentDetails;